module.exports = __webpack_public_path__ + "img/ba.16e089e9.svg";